import React, { Component } from 'react';
import { Col, Row, Button, Card, CardHeader, CardBody } from 'reactstrap';
import String from '../../../../assets/Locales/teacher_locales'
import noGroup from '../../../../assets/Images/NotFound/student - group.png';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios'
import { API_ENDPOINT } from '../../../../AppConfig'
import person from '../../../../assets/Images/driver.jpg'
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import DeleteComp from '../../../../components/DeleteModal/deleteModal'
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import '../AllAssistants/Assistants.css'
import './viewAssistant.css'
import Lottie from 'react-lottie';
import animationData from '../../../../components/lotties/pinjump.json'

class ViewAssistants extends Component {
    state = {
        user: '',
        groups: [],
        noGroups: false,
        Delete: false,
        redirect: false,
        isStopped: false,
        isPaused: false
    }

    componentWillMount() {
        if (this.props.location.state) {
            this.GetAssistant()
            this.GetAssistantGroups()
        }
        else {
            return (
                <Redirect to={{
                    pathname: '/home'
                }} />
            )
        }

    }
    GetAssistant() {
        this.props.showLoading()
        let Id = this.props.location.state.id
        let url = `${API_ENDPOINT}/userInfo?user=${Id}`
        let token = `Bearer ${this.props.token}`
        axios.get(url, {
            headers: {
                "Accept-Language": this.props.lang,
                Authorization: token
            }
        })
            .then(response => {
                this.props.hideLoading()
                // console.log("GETASSIS res", response.data)
                this.setState({ user: response.data.user })
            }).catch(error => {
                this.props.hideLoading()
                // console.log("GETASSIS error:", error.response);
            })
    }
    GetAssistantGroups() {
        let Id = this.props.location.state.id
        let url = `${API_ENDPOINT}/groups?assisstant=${Id}`
        let token = `Bearer ${this.props.token}`
        axios.get(url, {
            headers: {
                "Accept-Language": this.props.lang,
                Authorization: token
            }
        })
            .then(response => {
                // console.log("GETGROUP res", response.data.data)
                this.setState({ groups: response.data.data, noGroups: true })
            }).catch(error => {
                // console.log("GETGROUP error:", error.response);
            })
    }

    CancelDelete = () => {
        this.setState({ Delete: false })
    }
    DeleteAssistant = () => {
        this.props.showLoading()
        let uri = `${API_ENDPOINT}/delete`;
        let data = {
            userId: this.props.location.state.id,
            deleteReason: 'not suitable'
        }
        axios.delete(uri, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.props.token}`
            }, data
        })
            .then(response => {
                this.props.hideLoading()
                // console.log("DeleteAssistantRequest succ", response.data);
                this.setState({ Delete: false, redirect: true })
            }).catch(error => {
                this.props.hideLoading()
                // console.log("DeleteAssistantRequest err", error.response);
            })
    }

    render() {

        String.setLanguage(this.props.lang)
        let user = this.state.user
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return (
            <div className="AddLevel">
                <div className="mb-3 headerWrapper">
                    <Row>
                        <Col>
                            <h4> <span style={{ color: "#585858" }}> <Link style={{ color: "#585858" }} to="/Assistans">{String.Allassistant} </Link>- </span> <span> {user.firstName + ' ' + user.secondName} </span> </h4>
                        </Col>
                    </Row>
                </div>
                <div className="AddLevelsBTNs" style={{ direction: this.props.lang === 'ar' ? 'rtl' : 'ltr', minHeight: window.innerHeight - 180 }}>
                    {/* style={{ minHeight: '450px' }} */}
                    {
                        this.state.user ? <Row >
                            <Col className="first-section-view" md="12">
                                <img src={user.image === "" ? person : API_ENDPOINT + user.image} alt="user profile" />
                            </Col>
                            <Col style={{ textAlign: 'center', color: "#BC9345" }} md="12"> <h5> {user ? user.firstName + ' ' + user.secondName : "..."} </h5> </Col>
                            <Col style={{ textAlign: 'center', color: "#585858" }} md="12"> <h5> {user ? user.phone : "..."} </h5> </Col>
                            <div className="view-assistant-Btns" id="assistant-Btn">
                                <Link to={{
                                    pathname: `/conversation`,
                                    state: { id: user.id, user: user }
                                }}>
                                    <Button style={{ backgroundColor: "#fff", backgroundImage: "none", color: "#000", marginBottom: "10px" }}> {String.sendMessage} </Button> </Link>
                                {this.props.userType === "TEACHER" && <Link to={{ pathname: '/update-assistant', state: { id: user.id } }}><Button> {String.EditData} </Button></Link>}
                            </div>
                            <div className="border-view" style={{ marginRight: this.props.lang === 'ar' && '5px', marginLeft: this.props.lang === 'en' && '5px' }}></div>
                            {this.state.groups.length > 0 && this.state.groups.map((item, index) => (
                                <Col md="4">
                                    <Card className="subject-card" id="teacherCard">
                                        <CardHeader> {item.name} </CardHeader>
                                        <CardBody style={{ backgroundColor: '#EEEEEE', textAlign: this.props.lang === 'ar' ? 'right' : 'left', padding: '0.8rem' }}>
                                            {
                                                item.assisstants.map((element, index) => {
                                                    return (
                                                        element.assisstant.id === this.props.location.state.id ? element.assisstant.rules.length > 0 ?
                                                            <ul className="list-assistantCard" style={{ padding: '0' }}>
                                                                {element.assisstant.rules.map((rule, index) => {
                                                                    return (
                                                                        <li> <span> <div className="circle-list"> </div> </span>{rule.rule.name} </li>
                                                                    )

                                                                })}
                                                            </ul> :
                                                            <ul className="list-assistantCard" style={{ padding: '0' }}>
                                                                <li> <span> <div className="circle-list"> </div> </span>{String.assignRules} </li>
                                                            </ul> : ''
                                                    )
                                                })
                                            }
                                        </CardBody>
                                    </Card>

                                </Col>
                            ))
                            }
                            {(this.state.groups.length === 0 && this.state.noGroups) &&
                                <Col style={{ textAlign: 'center', color: "#585858" }} md="12">
                                    <img src={noGroup} alt={String.noGroups} style={{ height: '180px' }} />
                                    <h5> {String.noGroups} </h5>
                                </Col>
                            }
                        </Row> :
                            <Row >

                                <div className="w-100 text-center animationStyle">
                                    <Lottie options={defaultOptions}
                                        // height={400}
                                        // width={400}
                                        isStopped={this.state.isStopped}
                                        isPaused={this.state.isPaused} />
                                </div>
                            </Row>
                    }
                    {this.state.noGroups && this.props.userType === "TEACHER" &&
                        <h6 className="assistant-delete" onClick={() => this.setState({ Delete: true })}> {String.deleteAssis} </h6>}
                    {this.state.Delete &&
                        <DeleteComp title={String.deleteAssisQ} Cancel={this.CancelDelete} Delete={this.DeleteAssistant} />
                    }
                    {this.state.redirect && <Redirect to="/Assistans" />}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        lang: state.lang.lang,
        token: state.login.token,
        userType: state.login.userType

    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        showLoading,
        hideLoading
    }
    , dispatch
)
export default (connect(mapStateToProps, mapDispatchToProps)(ViewAssistants))